<div class="modal fade modal-confirmation" id="downloadModal" tabindex="-1" aria-labelledby="downloadModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-0">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="downloadModalLabel">{{ 'CHECK.DOWNLOAD_MODAL_TITLE' | translate }}</h1>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <img src="assets/icons/closeOutlined.svg" />
                </button>
            </div>
            <div class="modal-body">
                <div class="data-document d-flex">
                    <label class="right-line">{{ this.institutionName }}</label>
                    <label class="right-line">{{ this.wardName}}</label>
                    <label>{{ this.departmentName }}</label>
                </div>
                <div class="detail-document">
                    <label class="right-line">{{creationDate}}</label>
                    <label>{{creationHour}}</label>
                </div>
                <div class="format-document">
                    <div class="title-format">{{ 'CHECK.FORMAT' | translate }}</div>
                    <div class="detail-format">
                        <img src="assets/icons/wordFormat.svg" />
                        <span>Word</span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn-bd-empty" data-dismiss="modal" (click)="closeModal()">{{ 'BUTTON.CANCEL' | translate }}</button>
                <button type="button" class="btn-bd" data-dismiss="modal" (click)="download()">{{ 'CHECK.DOWNLOAD' | translate }}</button>
            </div>
        </div>
    </div>
</div>
